import Locales from 'UdeskLocales';
import React, { FC } from 'react';
import { Icon } from 'udesk-ui';

interface TempalteProps {
    authorized?: boolean;
}

const Tempalte: FC<TempalteProps> = ({ authorized }) => {
    const locales = Locales['current'];

    let { unauthorized, authorized: hasAuthorized } = locales.pages.admin.systemIntegration;

    return (
        <>
            <Icon
                antdIcon={true}
                type={authorized ? 'CheckCircleFilled' : 'ExclamationCircleFilled'}
                style={{ color: authorized ? '#52c41a' : '#faad14', fontSize: '22px' }}
            />
            <div style={{ fontWeight: 600, fontSize: '18px', marginLeft: 8 }}>
                {authorized ? hasAuthorized : unauthorized}
            </div>
        </>
    );
};

export default Tempalte;
